import { setElementOnClick } from '../../ui_utils/DomUtils.ts';
export class UILoadingRingController {
    hideLoading() {
        if (this.loadingView.style.display != 'none') this.loadingView.style.display = 'none';
    }
    showLoading() {
        if (this.loadingView.style.display != 'flex') this.loadingView.style.display = 'flex';
        if (this.loadingRing.style.display != 'block') this.loadingRing.style.display = 'block';
        if (this.loadingError.style.display != 'none') this.loadingError.style.display = 'none';
    }
    showLoadingError() {
        if (this.loadingView.style.display != 'flex') this.loadingView.style.display = 'flex';
        if (this.loadingRing.style.display != 'none') this.loadingRing.style.display = 'none';
        if (this.loadingError.style.display != 'block') this.loadingError.style.display = 'block';
        setElementOnClick(this.errorRefreshButton, ()=>location.reload());
    }
    constructor(base){
        this.loadingView = document.getElementById(base + 'loading_ring_container');
        this.loadingRing = document.getElementById(base + 'loading_ring');
        this.loadingError = document.getElementById(base + 'loading_error');
        this.errorRefreshButton = document.getElementById(base + 'loading_error_button');
    }
}
